// Custom events have been added to the theme to make adding
// custom functionality easier. The below events have been
// exposed as well as the associated data for each event.
// To enable this functionality update the 'useCustomEvents' variable in
// the theme.liquid file to 'true'.

// Toast Function
function showToast(message, type = 'success') {
  const toast = document.createElement('div');
  toast.className = `toast ${type}`;
  toast.textContent = message;
  document.body.appendChild(toast);

  // Trigger reflow to apply the initial styles
  toast.offsetHeight;

  // Add the show class to make the toast visible
  toast.classList.add('show');

  // Remove the toast after 3 seconds
  setTimeout(() => {
    toast.classList.remove('show');
    setTimeout(() => {
      toast.remove();
    }, 300); // Wait for the transition to complete
  }, 3000);
}

// This event fires whenever an item has been added to the cart.
// This event is exposed when the ajax cart is enabled.
// The product object is passed within the detail object.
document.addEventListener("cart:item-added", function (evt) {
  console.log("Item added to the cart");
  console.log(evt.detail.product);
  showToast("Item added to the cart", 'success');
});

// This event fires whenever the cart is updated.
// This event is exposed when the ajax cart is enabled.
// The cart object is passed within the detail object.
document.addEventListener("cart:updated", function (evt) {
  console.log("Cart updated");
  console.log(evt.detail.cart);
  showToast("Cart updated", 'success');
});

// This event fires whenever there is an error when adding an item to the cart.
// This error is typically due to a product not having sufficient stock.
// The error message is passed within the detail object.
document.addEventListener("cart:error", function (evt) {
  console.log("Cart error");
  console.log(evt.detail.errorMessage);
  showToast("Cart error: " + evt.detail.errorMessage, 'error');
});

// This event fires whenever the quick cart is opened.
// This event is exposed when the ajax cart is enabled.
// The cart object is passed within the detail object.
document.addEventListener("quick-cart:open", function (evt) {
  console.log("Quick cart opened");
  console.log(evt.detail.cart);
  showToast("Quick cart opened", 'success');
});

// This event fires whenever the quick cart is closed.
// This event is exposed when the ajax cart is enabled.
document.addEventListener("quick-cart:close", function () {
  console.log("Quick cart closed");
  showToast("Quick cart closed", 'success');
});

// This event fires whenever a variant product is selected.
// This event is exposed when a 'Variant selectors' block has been added to
// a product template or featured product section
// The selected variant object is passed within the detail object.
document.addEventListener("product:variant-change", function (evt) {
  console.log("Product variant changed");
  console.log(evt.detail.variant);
  showToast("Product variant changed", 'success');
});

// This event fires whenever a product quantity is updated.
// This event is exposed when a 'Quantity selector' block has been added to
// a product template or featured product section
// The quantity and selected variant object is passed within the detail object.
document.addEventListener("product:quantity-update", function (evt) {
  console.log("Product quantity updated");
  console.log(evt.detail.quantity, evt.detail.variant);
  showToast("Product quantity updated", 'success');
});

// This event fires whenever quickview modal is opened.
// This event is exposed when the 'Enable quick view' feature is enabled
// And a quick view modal is opened.
document.addEventListener("quickview:loaded", function () {
  console.log("Quickview loaded");
  showToast("Quickview loaded", 'success');
});

// Variant Selector Logic
document.querySelectorAll('.variant-select').forEach(function(select) {
  select.addEventListener('change', function(event) {
    var selectedVariantId = event.target.value;
    var productId = event.target.getAttribute('data-product-id');

    // Update the "Add to Cart" button to use the selected variant ID
    var addToCartButton = document.querySelector('.btn--add-to-cart[data-product-id="' + productId + '"]');
    addToCartButton.setAttribute('data-variant-id', selectedVariantId);

    // Dispatch a custom event for variant change
    var selectedVariant = { id: selectedVariantId }; // Minimal variant object
    var variantChangeEvent = new CustomEvent('product:variant-change', {
      detail: { variant: selectedVariant }
    });
    document.dispatchEvent(variantChangeEvent);
  });
});

// Add to Cart Logic
document.querySelectorAll('.btn--add-to-cart').forEach(function(button) {
  button.addEventListener('click', function() {
    var variantId = button.getAttribute('data-variant-id');
    var originalText = button.textContent;

    // Shopify Ajax API call to add item to cart
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [{ id: variantId, quantity: 1 }]
      })
    })
    .then(response => response.json())
    .then(data => {
      console.log('Item added to cart:', data);
      button.textContent = 'Added to Cart';
      setTimeout(function() {
        button.textContent = originalText;
      }, 3000);
      showToast("Item added to cart", 'success');
      var event = new CustomEvent('apps:product-added-to-cart');
      document.dispatchEvent(event);
    })
    .catch(error => {
      console.error('Error adding to cart:', error);
      showToast("Failed to add item to cart: " + error.message, 'error');
      var errorEvent = new CustomEvent('cart:error', { detail: { errorMessage: error.message } });
      document.dispatchEvent(errorEvent);
    });
  });
});

// Refresh Cart Logic
document.addEventListener('apps:product-added-to-cart', function() {
  console.log('Refreshing quick cart and cart count');
  showToast("Refreshing cart", 'success');
  var event = new CustomEvent('quick-cart:open');
  document.dispatchEvent(event);
});

// Banner Click Logic
// document.querySelector('.sales-banner-clickable').onclick = function() {
//   window.location.href = "https://thespiceway.com/collections/fall";
//   showToast("Redirecting to Fall Collection", 'success');
// };

// document.querySelector('.sales-banner-clickable-two').onclick = function() {
//   window.location.href = "https://thespiceway.com/collections/thanksgiving";
//   showToast("Redirecting to Thanksgiving Collection", 'success');
// };